module.exports = __webpack_public_path__ + "images/banner-fujian.jpg?dbc03364c9fc5b831af9bb7bd9815f71";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-fujian.jpg
// module id = 170
// module chunks = 1